import {SET_SCHEMAS, GET_MANUFACTURING_DATA, SET_MANUFACTURING_PAGINATION} from "../constants/Manufacturing";
import {SIGNOUT} from "../constants/Auth";

const initialState = {
    schemas: [],
    totalItems: 0,
    manufacturing_data: [],
    page: 1,
    limit: 24,
}

const manufacturing = (state = initialState, action) => {
    switch (action.type) {
        case SET_SCHEMAS:
            return {
                ...state,
                schemas: action.schemas
            }
        case GET_MANUFACTURING_DATA:
            return {
                ...state,
                totalItems: action.totalItems,
                manufacturing_data: action.manufacturing_data,
            }
        case SET_MANUFACTURING_PAGINATION:
            return {
                ...state,
                page: action.page,
                limit: action.limit,
            }
        case SIGNOUT:
            return initialState;
        default:
            return state
    }
}

export default manufacturing;